<template>
  <div
    class="message-bubble"
    :class="{
      reverse: message.flow === 'out',
    }"
    ref="htmlRefHook"
  >
    <img
      class="avatar"
      :src="avatarC"
      :onerror="`this.src='${defaultAvatarUrl}'`"
    />
    <main
      class="message-area"
      :class="{
        'message-area__in': message.flow === 'in',
        'message-area__out': message.flow === 'out',
      }"
    >
      <template v-if="message.flow === 'out'">
        <!-- 群内私聊 -->
        <label
          v-if="type === 'group' && message.isPrivateMsg === 1"
          class="name"
          >我对
          <span class="name-text ellipsis">
            {{ message?.privateInfo?.to?.name || "未知" }}
          </span>
          <span class="private-chat">(私聊)</span>
        </label>
        <!-- 私聊会话 -->
        <label v-else class="name">
          <span class="name-text ellipsis">{{ message.nick || "未知" }}</span>
        </label>
      </template>
      <div class="name-wrap" v-else-if="message.flow === 'in'">
        <!-- 用户角色 -->
        <span v-if="type === 'group' && handleRole" class="role-label">{{
          handleRole
        }}</span>
        <!-- 群内私聊 -->
        <label
          v-if="type === 'group' && message.isPrivateMsg === 1"
          class="name"
        >
          <span class="name-text ellipsis">{{
            message?.privateInfo?.from?.name || "未知"
          }}</span
          >对我
          <span class="private-chat">(私聊)</span>
        </label>
        <!-- 私聊会话 -->
        <label v-else class="name">
          <span class="name-text ellipsis">{{
            message.nick || currentSession.name || "未知"
          }}</span>
        </label>
      </div>

      <div
        class="message-content message-content-out"
        :class="{
          'no-bubble-wrap': message.type === 'file',
        }"
      >
        <slot />
        <div v-if="message.flow === 'out'" class="message-status">
          <!-- 发送状态 -->
          <div
            @click="resendMessage(message)"
            class="message-fail"
            v-if="message.status === 'fail'"
          >
            <img src="./../../../assets/images/chat/error.png" alt="" />
          </div>
          <div v-else-if="message.status === 'unSend'" class="message-sending">
            <img src="./../../../assets/images/chat/loading.png" alt="" />
          </div>
        </div>
      </div>
      <!-- 引用消息 -->
      <message-quote
        class="message-quote"
        :showCloseButton="false"
        v-if="message.cloudCustomData?.replyMsg"
        :quoteMessage="handleQuoteMessage(message.cloudCustomData)"
      />
    </main>
  </div>
</template>

<script>
import { handleTextMessageShowContext } from "@saas/components/src/utils/im/message-format";
import { getCdnUrl } from "@saas/components/src";
import MessageQuote from "../message-components/MessageQuote.vue";
import { mapState } from "vuex";
export default {
  props: {
    message: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: "group",
    },
    currentSession: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isSending: false,
      defaultAvatarUrl: getCdnUrl("/cdn/static/images/im_avatar.png"),
    };
  },
  components: {
    MessageQuote,
  },
  computed: {
    ...mapState("newChat", ["liveInfo"]),
    handleRole() {
      if (this.message?.from) {
        const userId = this.message?.from;
        if (userId === this.liveInfo.teacher_id) {
          return "教师";
        } else if (userId === this.liveInfo.assistant_teacher_id) {
          return "助教";
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    avatarC() {
      if (this.message?.avatar) {
        const hasQueryParam = this.message.avatar.includes("?");
        return (
          this.message.avatar +
          (hasQueryParam ? "&imageView2/0/w/50" : "?imageView2/0/w/50")
        );
      } else {
        return getCdnUrl("/cdn/static/images/im_avatar.png");
      }
    },
  },
  methods: {
    // 处理引用消息
    handleQuoteMessage(cloudCustomData) {
      const { replyMsg, isPrivateMsg, privateInfo } = cloudCustomData;
      const { type } = replyMsg;
      let showContext = "";
      if (type === "text") {
        showContext = handleTextMessageShowContext(replyMsg.text);
      }
      if (type === "image") {
        showContext = {
          url: replyMsg.imgUrl,
          imageWidth: replyMsg.imageWidth,
          imageHeight: replyMsg.imageHeight,
        };
      }
      if (type === "file") {
        showContext = {
          name: replyMsg.fileName,
        };
      }
      return {
        ...replyMsg,
        isPrivateMsg,
        privateInfo,
        showContext,
      };
    },
    resendMessage(message) {
      if (this.isSending) {
        return;
      }
      this.isSending = true;
      if (message.status !== "fail") {
        return;
      }
      console.log("==zy==handle-resendMessage");
      this.$emit("resendMessage", message);
      setTimeout(() => {
        this.isSending = false;
      }, 1000);
    },
  },
};
</script>
<style lang="scss" scoped>
.message-quote {
  margin-top: 4px;
}
.avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}
.message-area {
  max-width: 282px;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 2px 2px 0;
  &.no-bubble-wrap {
  }
  &.message-area__out {
    align-items: end;
    .name {
    }
  }
  .name-wrap {
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    width: fit-content;
    .name {
      padding-bottom: 0;
    }
  }
  // 用户角色
  .role-label {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 14px;
    background: #052814;
    border-radius: 4px 4px 4px 4px;
    padding: 0 3px;
    font-weight: 500;
    font-size: 10px;
    color: #17c964;
    line-height: 1;
  }
  .name {
    margin: 0 4px;
    font-weight: 500;
    font-size: 12px;
    color: #86909c;
    line-height: 30px;
    letter-spacing: 0;
    display: flex;
    flex: 1;
    .private-chat {
      color: #165dff;
    }
    .name-text {
      flex: 1;
    }
  }
  .time {
    text-align: right;
    padding-bottom: 4px;
    font-weight: 400;
    letter-spacing: 0;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #747573;
    line-height: 17px;
  }
  .message-content:not(.no-bubble-wrap) {
    .message-component {
      padding: 8px;
      letter-spacing: 0;
      word-wrap: break-word;
      word-break: break-all;
      border-radius: 8px 8px 8px 8px;
      // font-weight: 500;
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
    }
  }
  .message-content {
    position: relative;
    .message-status {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translate(-100%, -50%);
      padding-right: 4px;
    }
    &-out:not(.no-bubble-wrap) {
      .message-component {
        background: rgba(22, 93, 255, 0.2);
        width: fit-content;
        border-radius: 8px 8px 8px 8px;
      }
    }
    &-role:not(.no-bubble-wrap) {
      background: #e8e7ff;
      width: fit-content;
    }
    &-in:not(.no-bubble-wrap) {
      background: #f5f5f6;
      width: fit-content;
    }
  }
}

.message-bubble-file .message-area .message-content {
  width: 240px;
  background: #fff;
  border-radius: 2px 8px 8px 8px;
  height: 64px;
  overflow: hidden;
  padding: 0;
  border: 1px solid #e5e5e5;
}
.reverse.message-bubble-file .message-area .message-content {
  border-radius: 8px 2px 8px 8px;
}
.reverse {
  flex-direction: row-reverse;
  justify-content: flex-start;
}
.message-bubble {
  width: 100%;
  display: flex;
  padding-bottom: 16px;

  .message-fail,
  .message-sending {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 20px;
      height: 20px;
    }
  }
  .message-sending {
    img {
      animation: rotate 2s linear infinite;
    }
  }
}

.fail {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  background: red;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
